import { z } from 'zod';

import { bloodGroups, patientGenders } from './types';

export const patientFormSchema = z.object({
  medicalRecordNumber: z.string().trim().min(3, 'Use at least 3 characters').max(30),
  firstName: z.string().trim().min(1, 'First name is required').max(80),
  lastName: z.string().trim().min(1, 'Last name is required').max(80),
  dateOfBirth: z.string().min(1, 'Date of birth is required').refine(
    (value) => new Date(value) <= new Date(),
    'Date of birth cannot be in the future',
  ),
  gender: z.enum(patientGenders),
  phone: z.string().trim().regex(/^\d{10}$/, 'Enter a 10 digit phone number'),
  email: z.union([z.email('Enter a valid email'), z.literal('')]),
  bloodGroup: z.enum(bloodGroups),
  address: z.string().trim().min(1, 'Address is required').max(300),
  state: z.string().trim().max(120).optional(),
  district: z.string().trim().max(120).optional(),
  pinCode: z.string().trim().max(12).optional(),
});

export type PatientFormValues = z.infer<typeof patientFormSchema>;
